
// AppManager.js

import { firestore, auth, storage } from './firebase';
import { 
  doc, 
  setDoc, 
  addDoc,
  getDoc, 
  updateDoc, 
  deleteDoc, 
  collection, 
  getDocs, 
  query, 
  where, 
  orderBy, 
  limit 
} from 'firebase/firestore';
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  sendPasswordResetEmail 
} from 'firebase/auth';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import useStore from './store'; // Import the store
import axios from 'axios';
import Stripe from 'stripe';
import { Timestamp } from 'firebase/firestore';
import mixpanel from 'mixpanel-browser';
import { getAuth } from 'firebase/auth';
import React, { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
 


// Initialize Stripe with your secret key
const stripe = new Stripe('pk_test_51OfrFTHxM7j6JEg1hqlVtVvyBkkOwjBUm5yFG2ZKkyfwbQpQNt09OMGv0DSDID5b4UYkP9yxrAmFhVUfYlcsGcpg00CjV6cJLx');

// Base URL for your DatastoreManager backend API
const BASE_URL = 'https://aiit-gmg22qjzza-ue.a.run.app'


 

const AuthListener = () => {
  const {
    setUser, setUserProfile, setBusinessProfile,
    setBusinessId, setDatastoreId,
    setIsLoading, setError,
    setSubscriptionStatus, setOnboardComplete
  } = useStore(); // Use Zustand store

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsLoading(true);
        setUser(user);

        try {
          const firestoreService = new FirestoreService('Users');
          const userProfile = await firestoreService.getDocument(user.uid);

          setUserProfile(userProfile);
          setSubscriptionStatus(userProfile.subscriptionStatus || 'pending');
          setOnboardComplete(userProfile.onboardComplete || false);

          if (userProfile.businessId) {
            // Fetch the business document directly
            const businessService = new FirestoreService('Businesses');
            const businessProfile = await businessService.getDocument(userProfile.businessId);

            setBusinessProfile(businessProfile);
          }
        } catch (error) {
          console.error('Error loading user data:', error);
          setError(error.message);
        } finally {
          setIsLoading(false);
        }
      } else {
        // Reset states when user is not authenticated
        setUser(null);
        setUserProfile(null);
        setBusinessProfile(null);
        setSubscriptionStatus(null);
        setOnboardComplete(null);
      }
    });

    return () => unsubscribe();
  }, [
    setUser, setUserProfile, setBusinessProfile,
    setSubscriptionStatus, setOnboardComplete,
    setIsLoading, setError
  ]);

  return null; // No UI rendering
};



 


export class CalendarManager {
  constructor(baseUrl) {
    this.baseUrl = baseUrl; // Your server API base URL
  }

  // One function for all CRUD operations
  async manageEvents(calendarId, operation, eventId = null, eventData = null) {
    const url = `${this.baseUrl}/calendar/${calendarId}/events`;
    switch (operation) {
      case 'create':
        return (await axios.post(url, eventData)).data;
      case 'read':
        return (await axios.get(`${url}/${eventId}`)).data;
      case 'update':
        return (await axios.patch(`${url}/${eventId}`, eventData)).data;
      case 'delete':
        await axios.delete(`${url}/${eventId}`);
        return null;
      default:
        throw new Error(`Unknown operation: ${operation}`);
    }
  }

  async listEvents(calendarId) {
    const url = `${this.baseUrl}/calendar/${calendarId}/events`;
    return (await axios.get(url)).data;
  }

  async getCalendarDetails(calendarId) {
    const url = `${this.baseUrl}/calendar/${calendarId}`;
    return (await axios.get(url)).data;
  }
}

 
const AccountManagerService = {

  createUserAccount: async (userData) => {
    try {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();

      const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/account/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

   

      if (!response.ok) {
        // Handle HTTP errors
        const errorResponse = await response.json();
        const errorMessage = errorResponse?.error || 'Failed to create user account.';
        console.error('Error creating user account:', errorMessage);
        throw new Error(errorMessage);
      }

      const data = await response.json(); // Parse the JSON response
      console.log('response data:', data);

      return data;
    } catch (error) {
      const errorMessage = error.message || 'An unexpected error occurred while creating user account.';
      console.error('Error creating user account:', errorMessage);
      throw new Error(errorMessage);
    }
  },
 

  // Additional methods as needed
};

 
 
const DatastoreManagerService = {
  manageDocuments: async (businessId, datastoreId, action, documentData) => {
    try {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();

      const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/datastore/manage_documents', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          business_id: businessId,
          datastore_id: datastoreId,
          action: action,
          document_data: documentData,
        }),
      });


      
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'An unexpected error occurred while managing documents.';
      console.error('Error managing documents:', errorMessage);
      throw new Error(errorMessage);
    }
  },

  manageInstructions: async (businessId, datastoreId, action, instructionData) => {
    try {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();


      // const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/datastore/manage_instructions', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     business_id: businessId,
      //     datastore_id: datastoreId,
      //     action: action,
      //     document_data: instructionData,
      //   }),
      // });

 
      // return response.data;
      console.log('placeholder');
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'An unexpected error occurred while managing instructions.';
      console.error('Error managing instructions:', errorMessage);
      throw new Error(errorMessage);
    }
  },

  // Additional methods as needed
};

 

class FirestoreService {
  constructor(collectionPath) {
    if (!collectionPath || typeof collectionPath !== 'string') {
      throw new Error('Collection path must be provided as a string');
    }

    const segments = collectionPath.split('/');
    if (segments.length % 2 === 0) {
      throw new Error('Invalid collection reference. Collection references must have an odd number of segments.');
    }

    this.collectionRef = collection(firestore, collectionPath);

  }


  async fetchUserProfile(userId) {
    try {
      const userRef = doc(firestore, `Users/${userId}`);
      const userSnap = await getDoc(userRef);
  
      if (!userSnap.exists()) {
        throw new Error('User profile not found');
      }
  
      return userSnap.data();
    } catch (error) {
      console.error('Error fetching user profile:', error);
      throw new Error('Failed to fetch user profile.');
    }
  }

  
  async updateSubscriptionStatus(userId, status) {
    try {
      const userRef = doc(firestore, `Users/${userId}`);
      await updateDoc(userRef, { subscriptionStatus: status });
    } catch (error) {
      console.error('Error updating subscription status:', error);
      throw new Error('Failed to update subscription status.');
    }
  }
  

  // Firestore methods for collections
  async getAllDocuments() {
    try {
      const querySnapshot = await getDocs(this.collectionRef);
      return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
      console.error('Error getting all documents:', error);
      throw new Error('Failed to get documents.');
    }
  }

  // Firestore methods for individual documents
  async getDocument(docId) {
    try {
      const docRef = doc(this.collectionRef, docId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        throw new Error('Document not found');
      }
    } catch (error) {
      console.log('Error getting document:', error);
      throw new Error('Failed to get document.');
    }
  }

  async createOrUpdateDocument(id = null, data) {
    try {
      let docRef;
      if (id) {
        docRef = doc(this.collectionRef, id);
        await setDoc(docRef, data, { merge: true });
      } else {
        docRef = await addDoc(this.collectionRef, data);
      }

      return docRef.id;
    } catch (error) {
      console.error('Error creating or updating document:', error);
      throw new Error('Failed to create or update document.');
    }
  }

  async updateDocument(id, data) {
    try {
      const docRef = doc(this.collectionRef, id);
      await updateDoc(docRef, data);
    } catch (error) {
      console.error('Error updating document:', error);
      throw new Error('Failed to update document.');
    }
  }

  async deleteDocument(id) {
    try {
      const docRef = doc(this.collectionRef, id);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting document:', error);
      throw new Error('Failed to delete document.');
    }
  }

  // File upload and management methods in Firebase Storage
  async uploadFile(userId, file, folder) {
    try {
      const filePath = `${folder}/${userId}/${file.name}`;
      const storageRef = ref(storage, filePath);
      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      return fileUrl;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw new Error('Failed to upload file.');
    }
  }

  async deleteFile(fileUrl) {
    try {
      const fileRef = ref(storage, fileUrl);
      await deleteObject(fileRef);
    } catch (error) {
      console.error('Error deleting file:', error);
      throw new Error('Failed to delete file.');
    }
  }

  /**
   * Check if a datastore exists for the given businessId and datastoreId.
   * @param {string} businessId 
   * @param {string} datastoreId 
   * @returns {boolean}
   */
  async datastoreExists(businessId, datastoreId) {
    try {
      const datastoreDocRef = doc(firestore, `Businesses/${businessId}/Datastores/${datastoreId}`);
      const datastoreSnap = await getDoc(datastoreDocRef);
      return datastoreSnap.exists();
    } catch (error) {
      console.error('Error checking datastore existence:', error);
      throw new Error('Failed to check datastore existence.');
    }
  }

  /**
   * Create a new datastore for the given businessId.
   * @param {string} businessId 
   * @param {object} datastoreData 
   * @returns {string} - datastoreId
   */
  async createDatastore(businessId, datastoreData) {
    try {
      const datastoreRef = await addDoc(collection(firestore, `Businesses/${businessId}/Datastores`), datastoreData);
      return datastoreRef.id;
    } catch (error) {
      console.error('Error creating datastore:', error);
      throw new Error('Failed to create datastore.');
    }
  }

  /**
   * Update the user's document with the datastoreId.
   * @param {string} userId 
   * @param {string} datastoreId 
   */
  async updateUserWithDatastore(userId, datastoreId) {
    try {
      const userDocRef = doc(firestore, `Users/${userId}`);
      await updateDoc(userDocRef, {
        datastoreId: datastoreId,
      });
    } catch (error) {
      console.error('Error updating user with datastore:', error);
      throw new Error('Failed to update user with datastore.');
    }
  }

  /**
   * Get datastoreId from the Businesses collection based on businessId.
   * @param {string} businessId 
   * @returns {string|null} - datastoreId or null if not found
   */
  async getDatastoreId(businessId) {
    try {
      const datastoresRef = collection(firestore, `Businesses/${businessId}/Datastores`);
      const q = query(datastoresRef, orderBy('createdAt', 'desc'), limit(1));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        return querySnapshot.docs[0].id;
      }
      return null;
    } catch (error) {
      console.error('Error fetching datastoreId:', error);
      throw new Error('Failed to fetch datastoreId.');
    }
  }
}





class AnalyticsService {
  constructor() {
    // this.token = 'your_mixpanel_project_token';// Replace with your Mixpanel token
    this.token = '2d52f3e2dfd57c79ce4f01ba836af616'
    mixpanel.init(this.token, { debug: true }); // Debug can be disabled in production
    this.firestoreService = new FirestoreService('analytics'); // Firestore collection for analytics
  }

  /**
   * Identify a user in Mixpanel and Firestore.
   * @param {string} userId - Unique identifier for the user (e.g., Firebase UID).
   * @param {object} traits - Additional user traits (e.g., email, name).
   */
  async identifyUser(userId, traits = {}) {
    if (!userId) {
      console.warn('User ID is required for identifyUser.');
      return;
    }

    try {
      // Mixpanel tracking
      mixpanel.identify(userId);
      mixpanel.people.set(traits);
      console.log('Mixpanel user identified:', userId, traits);

      // Firestore logging
      await this.firestoreService.createOrUpdateDocument(userId, traits);
    } catch (error) {
      console.error('Error identifying user:', error);
    }
  }

  /**
   * Track an event in Mixpanel and Firestore.
   * @param {string} eventName - Name of the event to track.
   * @param {object} properties - Additional properties to attach to the event.
   */
  async trackEvent(eventName, properties = {}) {
    if (!eventName) {
      console.warn('Event name is required for trackEvent.');
      return;
    }

    try {
      // Mixpanel tracking
      mixpanel.track(eventName, properties);
      console.log('Event tracked:', eventName, properties);

      // Firestore logging
      const eventId = `${eventName}-${Date.now()}`;
      await this.firestoreService.createOrUpdateDocument(eventId, {
        eventName,
        ...properties,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }

  /**
   * Update user profile properties in Mixpanel and Firestore.
   * @param {string} userId - Unique identifier for the user.
   * @param {object} properties - Properties to update on the user's profile.
   */
  async updateUserProfile(userId, properties = {}) {
    if (!userId || Object.keys(properties).length === 0) {
      console.warn('User ID and properties are required for updateUserProfile.');
      return;
    }

    try {
      // Mixpanel profile update
      mixpanel.people.set(properties);
      console.log('User profile updated:', properties);

      // Firestore logging
      await this.firestoreService.updateDocument(userId, properties);
    } catch (error) {
      console.error('Error updating user profile:', error);
    }
  }

  /**
   * Fetch analytics events for a specific user from Firestore.
   * @param {string} userId - Unique identifier for the user.
   * @returns {array} - Array of event documents.
   */
  async fetchUserEvents(userId) {
    try {
      const events = await this.firestoreService.getAllDocuments();
      console.log('Fetched user events:', events);
      return events.filter((event) => event.userId === userId);
    } catch (error) {
      console.error('Error fetching user events:', error);
      throw new Error('Failed to fetch user events.');
    }
  }
}


const analyticsService = new AnalyticsService();
export default FirestoreService ;
export { FirestoreService, analyticsService, DatastoreManagerService,AccountManagerService, AuthListener };
